export interface IApiLpAdapterSetting {
  key?: string;
  value?: string;
}

export enum ApiLpConnectionStatus {
  Backup = 'BACKUP',
  Error = 'ERROR',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
}

export interface IApiLpConnectionBase {
  adapterSettings: IApiLpAdapterSetting[];
  host: string;
  port: number;
  login: string;
  password: string;
}

export interface IApiLpConnectionState {
  error?: string;
  status: ApiLpConnectionStatus;
}

export interface IApiLpConnection extends Omit<IApiLpConnectionBase, 'adapterSettings'>, IApiLpConnectionState {
  adapter: {
    name: string;
    settings: IApiLpAdapterSetting[];
  };
}
